import React, { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

import Box from '@amzn/meridian/box';
import { AdminConfigPaths } from 'src/store/adminConfigPageSlice/common/constants';
import {
  fetchMeasureUnits,
  fetchRegions,
  fetchTaskGroups,
  fetchTasks,
  setTaskSearchFieldValue,
} from 'src/store/adminConfigPageSlice/taskConfigPageSlice/taskConfigPageSlice';
import { useAppDispatch, useAppSelector } from 'src/store/store';

import './taskConfiguration.scss';

import TaskConfigurationTabGroup from './taskConfigurationTabGroup/taskConfigurationTabGroup';
import TaskGroups from './taskGroups/taskGroups';
import Tasks from './tasks/tasks';

// **** Components **** //

/**
 * Default Component
 */
const TaskConfiguration = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { userLoading } = useAppSelector((state) => state.user);
  const { TASKS, TASK_GROUPS, root } = AdminConfigPaths.Task;

  // Fetch back-end data
  useEffect(() => {
    if (userLoading === 'fulfilled') {
      dispatch(fetchMeasureUnits());
      dispatch(fetchTasks());
      dispatch(fetchRegions());
      dispatch(fetchTaskGroups());
    }
    return () => {
      dispatch(setTaskSearchFieldValue(''));
    };
  }, [userLoading]);

  return (
    <div>
      <Box spacingInset="500 none none none">
        <TaskConfigurationTabGroup />
      </Box>
      <Box type="outline" spacingInset="200 500 400 500">
        {location.pathname === TASKS || location.pathname === root ? (
          <Tasks />
        ) : location.pathname === TASK_GROUPS ? (
          <TaskGroups />
        ) : null}
      </Box>
    </div>
  );
};

// **** Export **** //

export default TaskConfiguration;
